import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TableHeaderCell from '../../atoms/TableHeaderCell';
import { useStyles } from '../../../styles/mapStylesCustom';

const TableHeaderRow = ({
  tableHeaders,
  allSelected,
  hasSelectAllButton,
  hasTrash,
  openTrash,
  selectAll,
  sort,
  handleSort
}) => {
  const classes = useStyles();
  return (
    <thead style={{ backgroundColor: '#EEEEEE', borderRadius: '30%' }}>
      <tr>
        {hasSelectAllButton && (
          <th className="align-middle">
            <Button
              variant={allSelected ? 'success' : 'light'}
              onClick={selectAll}
              block
              title="Select All"
            >
              <FontAwesomeIcon icon={['far', allSelected ? 'check-circle' : 'circle']} size="lg" />
            </Button>
          </th>
        )}
        {tableHeaders.map(cell => (
          <TableHeaderCell {...cell} sort={sort} handleSort={handleSort} key={uuid()} />
        ))}
        <th className="align-middle">
          <Button
            variant="light"
            onClick={openTrash}
            block
            disabled={hasTrash !== true}
            title="Open Trash"
            className={classes.azulIpsilumButton}
          >
            <FontAwesomeIcon icon="trash-alt" />
          </Button>
        </th>
      </tr>
    </thead>
  );
};

TableHeaderRow.defaultProps = {
  allSelected: false,
  hasSelectAllButton: false,
  hasTrash: false,
  openTrash: () => console.error('no trash to open'),
  selectAll: () => console.error('nothing to select'),
  sort: { name: 1 },
  handleSort: () => console.error('no sorting function'),
  isFree: false
};

TableHeaderRow.propTypes = {
  tableHeaders: PropTypes.array.isRequired,
  allSelected: PropTypes.bool,
  hasSelectAllButton: PropTypes.bool,
  hasTrash: PropTypes.bool,
  openTrash: PropTypes.func,
  selectAll: PropTypes.func,
  sort: PropTypes.object,
  handleSort: PropTypes.func,
  isFree: PropTypes.bool
};

export default TableHeaderRow;
